import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const QUESTION_WIDE = 'question--wde'
export const EACH_ALTERNATIVE = 'each--alternative'
export const AS_COLUMN = 'as--column'
export const CODE = 'code--'
export const LABEL = 'label--'
export const RENDER_ON = 'render--on--'
export const LOGIC_LABEL = 'logic--label'
export const NEXT = 'next--'
export const FINISH = 'FINISH--'
export const SCREENED = 'screened--'

export default {
  [PORTUGUESE]: {
    [QUESTION_WIDE]: 'Ao final da questão',
    [EACH_ALTERNATIVE]: 'Em cada alternativa',
    [AS_COLUMN]: 'Como uma coluna',
    [NEXT]: 'Próxima',
    [SCREENED]: 'Screened',
    [NEXT]: 'Próxima',
    [SCREENED]: 'Screened',
    [FINISH]: 'Terminar',
    [CODE]: 'Código',
    [LABEL]: 'Texto',
    [RENDER_ON]: 'Renderizar em',
    [LOGIC_LABEL]: 'Lógica ao marcar',
  },

  [ENGLISH]: {
    [QUESTION_WIDE]: 'At the end of question',
    [EACH_ALTERNATIVE]: 'On each alternative',
    [AS_COLUMN]: 'As a column',
    [NEXT]: 'Next',
    [SCREENED]: 'Screened',
    [FINISH]: 'Finish',
    [CODE]: 'Code',
    [LABEL]: 'Label',
    [RENDER_ON]: 'Render On',
    [LOGIC_LABEL]: 'Applied logic if selected',
  },

  [SPANISH]: {
    [QUESTION_WIDE]: 'Al final de la pregunta',
    [EACH_ALTERNATIVE]: 'En cada alternativa',
    [AS_COLUMN]: 'como columna',
    [NEXT]: 'Próxima',
    [SCREENED]: 'Screened',
    [FINISH]: 'Finalizar',
    [CODE]: 'Código',
    [LABEL]: 'Texto',
    [RENDER_ON]: 'Renderizar em',
    [LOGIC_LABEL]: 'Lógica ao marcar',
  },
}
